module.exports = __webpack_public_path__ + "static/media/athletes@2x.ba19a3b5.png";